import React from 'react';
import { FilterItem } from '../FilterItem';
import { SocialProfile } from '../../socialProfiles/SocialProfile';
import { GetTimeslots_workspace_timeslots } from '../../../models/legacy-graphql';
import { TimeslotFilterType } from '../../../models/calendar';
import { ProfileType } from './SocialProfileFilterGroup.controller';

export type SocialProfileFilterGroupViewProps = {
  profiles: ProfileType[] | null;
  timeslots: GetTimeslots_workspace_timeslots[];
  filters: TimeslotFilterType;
  isMobile?: boolean;
  loading: boolean;
  setSelectedFilter: (id: string) => void;
};

export const SocialProfileFilterGroupView = (props: SocialProfileFilterGroupViewProps): JSX.Element => {
  const profileTimeslotCount = (id: string): number =>
    props.timeslots.filter(timeslot => timeslot.socialProfiles.findIndex(p => p.id === id) !== -1).length ?? 0;

  const filterItems = props.profiles?.map((profile, index) => {
    const isSelected = profile.id === props.filters.profiles;

    return (
      <FilterItem
        key={`profileFilter.${profile.id}.${index}`}
        count={profileTimeslotCount(profile.id)}
        selected={isSelected}
        setSelectedHandler={() => {
          props.setSelectedFilter(profile.id);
        }}
        loading={props.loading}>
        <SocialProfile
          size={'small'}
          label={true}
          disconnected={!profile.connected}
          socialProfile={{
            id: profile.id,
            name: profile.displayName,
            provider: profile.provider,
            network: profile.network,
            genericProfile: profile.genericProfile
          }}
          image={profile.photoUrl}
        />
      </FilterItem>
    );
  });

  return <>{filterItems}</>;
};
